import React from 'react'
import update from 'immutability-helper';

import { quickBooksHandler } from '../../../helpers/Integrations/QuickBooks/QuickBooksHandler'
import { modal } from '../../../core/utilities/modal';

export default class QBEnterprise extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        var self = this;
    }

    componentWillUpdate(nextProps, nextState) {

    }

    downloadCertification() {
        quickBooksHandler.generateQWCCertification(function(response) {
            modal.showInfo("Certification will download shortly!", "success", "top", "center");
        });
    }

    render(){
        return (
            <div class="col-md-8 col-sm-7 col-xs-12">
                <div class="card">
                    <div class="header">
                        <h4 class="title"><i class="pe-7s-edit"></i> <small><i class="pe-7s-angle-right"></i></small> QB Enterprise</h4>
                        <p class="category">Integration</p>
                    </div>
                    <div class="content">
                        <div class="row">
                            <div class="col-md-12">
                                <p class="category"><b></b></p>
                            </div>
                            <div id="colorSelects">
                                <div class="col-md-12">
                                    <button type="button" id="save-color-coding" data-loading-text="Loading..." class="add-tenant btn btn-secondary btn-info btn-fill pull-left" autoComplete="off" onClick={this.downloadCertification.bind(this)}>
                                        Generate QWC File
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Settings/Integrations/QBEnterprise.jsx